import { render } from "./TvmServiceCoupons.vue?vue&type=template&id=2e442754&scoped=true"
import script from "./TvmServiceCoupons.js?vue&type=script&lang=js&external"
export * from "./TvmServiceCoupons.js?vue&type=script&lang=js&external"

import "./TvmServiceCoupons.vue?vue&type=style&index=0&id=2e442754&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e442754"],['__file',"src/components/ChatWidget/TvmServiceCoupons/TvmServiceCoupons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e442754"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e442754', __exports__)) {
    api.reload('2e442754', __exports__)
  }
  
  module.hot.accept("./TvmServiceCoupons.vue?vue&type=template&id=2e442754&scoped=true", () => {
    api.rerender('2e442754', render)
  })

}


export default __exports__